import { SVGProps } from 'react';
import { PaletteRarity, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

export type LootboxCardBackgroundProps = SVGProps<SVGSVGElement> & {
  rarity: keyof PaletteRarity;
};
export function LootboxCardBackground(props: LootboxCardBackgroundProps) {
  const theme = useTheme();
  const { rarity } = props;

  return (
    <Box sx={{ position: 'absolute', mt: -3.75, ml: 0.5 }}>
      <svg
        width="269"
        height="332.93"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <defs>
          <linearGradient
            y2="1.31739"
            x2="1.25191"
            y1="0.10199"
            x1="0.5"
            id="paint0_linear_5208_154918"
          >
            <stop stopColor={theme.palette.rarity[`${rarity}`]} />
            <stop
              stopColor={theme.palette.rarity[`${rarity}`]}
              offset="0.70313"
            />
          </linearGradient>
          <linearGradient
            y2="1.29902"
            x2="1.21515"
            y1="0.11207"
            x1="0.5061"
            id="paint1_linear_5208_154918"
          >
            <stop stopColor={theme.palette.rarity[`${rarity}`]} />
            <stop
              stopColor={theme.palette.rarity[`${rarity}`]}
              offset="0.70313"
            />
          </linearGradient>
          <linearGradient
            y2="0.49961"
            x2="1.28922"
            y1="0.4996"
            x1="-0.00984"
            id="paint2_linear_5208_154918"
          >
            <stop stopColor={theme.palette.rarity[`${rarity}`]} />
            <stop stopColor={theme.palette.rarity[`${rarity}`]} offset="1" />
          </linearGradient>
          <linearGradient
            y2="0.50405"
            x2="1.39474"
            y1="0.50405"
            x1="-0.07895"
            id="paint3_linear_5208_154918"
          >
            <stop stopColor={theme.palette.rarity[`${rarity}`]} />
            <stop stopColor={theme.palette.rarity[`${rarity}`]} offset="1" />
          </linearGradient>
        </defs>
        <g>
          <title>Layer 1</title>
          <path stroke="null" id="svg_1" opacity="undefined" fill="#000B1A" />
          <path
            stroke="url(#paint0_linear_5208_154918)"
            id="svg_2"
            opacity="undefined"
            strokeWidth="4"
          />
          <path
            stroke="null"
            id="svg_3"
            fill="#000D1F"
            d="m255.4607,2.22101l-224.86108,0c-3.02749,0 -5.93109,1.0742 -8.07236,2.98645l-12.57277,11.22789l240.43736,0l-0.00799,305.54431l-1.18528,1.61811l15.18256,-16.97277c1.61692,-1.80889 2.49845,-4.05547 2.49845,-6.3704l0,-287.83115c0,-5.63465 -5.11224,-10.20244 -11.41889,-10.20244z"
          />
          <path
            stroke="null"
            id="svg_4"
            fill="url(#paint1_linear_5208_154918)"
            d="m264.05399,309.78462l1.79981,1.28622l0,0l-1.79981,-1.28622zm-15.32025,17.14553l-1.92886,-1.12854c-0.67291,0.92035 -9.83754,7.89377 -4.78952,7.30074c5.04802,-0.59304 7.75079,-4.0254 8.51818,-4.88494l-1.79981,-1.28725zm-239.44225,-315.12914l-5.79112,5.7462l-2.29346,3.29405l6.1131,-2.13873l1.97148,-6.90153zm10.71532,-6.5019l-1.62904,-1.45789l0,0l1.62904,1.45789zm229.93103,11.34218l2.30449,0l0,-2.06126l-2.30449,0l0,2.06126zm-0.00807,308.65429l1.92771,1.12854l0.37678,-0.51428l0,-0.61425l-2.30449,0zm-221.7774,-320.95206l226.90028,0l0,-4.12251l-226.90028,0l0,4.12251zm236.11824,8.24503l0,290.76083l4.60898,0l0,-290.76083l-4.60898,0zm-2.01758,295.90882l-15.32025,17.14553l3.60077,2.57451l15.32025,-17.14656l-3.60077,-2.57348zm-253.3039,-290.39826l12.68684,-11.34212l-3.2582,-2.91577l-10.38681,9.31597l0.95817,4.94191zm240.98871,-3.51908l-242.61782,0l0,4.12251l242.61782,0l0,-4.12251zm0.72361,313.47866l1.19603,-1.63458l-3.85656,-2.25708l-1.19603,1.63458l3.85656,2.25708zm1.57281,-2.76311l0.00807,-308.65429l-4.60898,-0.0001l-0.00807,308.65439l4.60898,0zm12.03635,-21.9462c0,1.87162 -0.71094,3.68656 -2.01758,5.14799l3.60077,2.57348c1.95882,-2.19215 3.02579,-4.91507 3.02579,-7.72147l-4.60898,0zm-9.21796,-299.00586c5.09062,0 9.21796,3.69142 9.21796,8.24503l4.60898,0c0,-6.83041 -6.19101,-12.36754 -13.82694,-12.36754l0,4.12251zm-226.90028,-4.12251c-3.66587,0 -7.18183,1.30217 -9.77461,3.62022l3.2582,2.91577c1.7286,-1.54537 4.07249,-2.41347 6.51641,-2.41347l0,-4.12251z"
          />
          <path
            stroke={theme.palette.rarity[`${rarity}`]}
            id="svg_5"
            strokeLinecap="round"
            strokeWidth="6"
            d="m251.55101,15.12574l11,-8.46663"
          />
          <path
            stroke="white"
            id="svg_6"
            strokeWidth="1.5"
            fillOpacity="0.5"
            fill="url(#paint2_linear_5208_154918)"
            d="m28.12437,3.97934l232.55347,0.48545c0.26575,0.00056 0.59953,0.27997 0.19698,0.43398l-11.04026,8.71404c-0.69934,0.5519 -1.61431,0.8582 -2.56425,0.8582l-233.80891,0c-0.25666,0 -0.3879,-0.264 -0.21038,-0.423l8.75178,-7.835c1.59869,-1.43131 3.81094,-2.23849 6.12156,-2.23367z"
          />
          <path
            stroke="white"
            id="svg_7"
            strokeWidth="1.5"
            fillOpacity="0.5"
            fill="url(#paint3_linear_5208_154918)"
            d="m253.3098,16.51586l10.32598,-7.28978c0.19323,-0.13625 0.49381,-0.02504 0.49381,0.18254l0,245.3112c0,0.29229 -0.13121,0.5749 -0.36857,0.79557l-8.34953,7.75634c-0.90533,0.84203 -2.6134,0.32229 -2.6134,-0.79557l0,-245.04762c0,-0.34997 0.18727,-0.68291 0.51171,-0.91268z"
          />
        </g>
      </svg>
      {/* <svg
        width="234"
        height="323"
        viewBox="0 0 234 323"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M222 2H25.0798C22.4285 2 19.8857 3.05289 18.0105 4.92719L7 15.9323H217.561L217.554 315.414L216.516 317L229.812 300.364C231.228 298.591 232 296.389 232 294.12V12C232 6.47715 227.523 2 222 2Z"
          fill="#000D1F"
        />
        <path
          d="M229.812 300.364L231.374 301.612L231.374 301.612L229.812 300.364ZM216.516 317L214.842 315.905C214.258 316.798 214.478 317.994 215.343 318.62C216.207 319.246 217.412 319.083 218.078 318.249L216.516 317ZM7 15.9323L5.58614 14.5177L2.16989 17.9323H7V15.9323ZM18.0105 4.92719L16.5967 3.51263L16.5967 3.51263L18.0105 4.92719ZM217.561 15.9323L219.561 15.9323L219.561 13.9323H217.561V15.9323ZM217.554 315.414L219.227 316.509L219.554 316.01L219.554 315.414L217.554 315.414ZM25.0798 4H222V0H25.0798V4ZM230 12V294.12H234V12H230ZM228.249 299.115L214.953 315.751L218.078 318.249L231.374 301.612L228.249 299.115ZM8.41386 17.3468L19.4244 6.34175L16.5967 3.51263L5.58614 14.5177L8.41386 17.3468ZM217.561 13.9323H7V17.9323H217.561V13.9323ZM218.189 318.095L219.227 316.509L215.88 314.319L214.842 315.905L218.189 318.095ZM219.554 315.414L219.561 15.9323L215.561 15.9322L215.554 315.414L219.554 315.414ZM230 294.12C230 295.936 229.383 297.697 228.249 299.115L231.374 301.612C233.074 299.485 234 296.843 234 294.12H230ZM222 4C226.418 4 230 7.58172 230 12H234C234 5.37258 228.627 0 222 0V4ZM25.0798 0C21.8983 0 18.8469 1.26347 16.5967 3.51263L19.4244 6.34175C20.9246 4.84231 22.9588 4 25.0798 4V0Z"
          fill="url(#paint1_linear_5208_154918)"
        />
        <path
          d="M217 16L228 6"
          stroke={theme.palette.rarity.metaderby[`${rarity}`]}
          strokeWidth="6"
          strokeLinecap="round"
        />
        <path
          d="M24.9235 3.75833L224.443 4.24378C224.671 4.24434 224.779 4.52375 224.612 4.67776L215.14 13.3918C214.54 13.9437 213.755 14.25 212.94 14.25H12.3434C12.1232 14.25 12.0106 13.986 12.1629 13.827L19.6715 5.992C21.0431 4.56069 22.9411 3.75351 24.9235 3.75833Z"
          fill="url(#paint2_linear_5208_154918)"
          fillOpacity="0.5"
          stroke="white"
          strokeWidth="1.5"
        />
        <path
          d="M220.179 16.539L228.836 9.00706C228.998 8.86628 229.25 8.98119 229.25 9.19566V262.656C229.25 262.958 229.14 263.25 228.941 263.478L221.941 271.492C221.182 272.362 219.75 271.825 219.75 270.67V17.482C219.75 17.1204 219.907 16.7764 220.179 16.539Z"
          fill="url(#paint3_linear_5208_154918)"
          fillOpacity="0.5"
          stroke="white"
          strokeWidth="1.5"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5208_154918"
            x1="109.631"
            y1="47.224"
            x2="271.489"
            y2="417.763"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={theme.palette.rarity.metaderby[`${rarity}`]} />
            <stop
              offset="0.703125"
              stopColor={theme.palette.rarity.metaderby[`${rarity}`]}
            />
          </linearGradient>
          <linearGradient
            id="paint1_linear_5208_154918"
            x1="119.5"
            y1="35.75"
            x2="283.878"
            y2="414.389"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={theme.palette.rarity.metaderby[`${rarity}`]} />
            <stop
              offset="0.703125"
              stopColor={theme.palette.rarity.metaderby[`${rarity}`]}
            />
          </linearGradient>
          <linearGradient
            id="paint2_linear_5208_154918"
            x1="10"
            y1="9"
            x2="286.182"
            y2="9.00005"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={theme.palette.rarity.metaderby[`${rarity}`]} />
            <stop
              offset="1"
              stopColor={theme.palette.rarity.metaderby[`${rarity}`]}
            />
          </linearGradient>
          <linearGradient
            id="paint3_linear_5208_154918"
            x1="219"
            y1="141.5"
            x2="233"
            y2="141.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={theme.palette.rarity.metaderby[`${rarity}`]} />
            <stop
              offset="1"
              stopColor={theme.palette.rarity.metaderby[`${rarity}`]}
            />
          </linearGradient>
        </defs>
      </svg> */}
    </Box>
  );
}
